import { render, staticRenderFns } from "./SleepWorkshopComp.vue?vue&type=template&id=32f0f709&scoped=true"
import script from "./SleepWorkshopComp.vue?vue&type=script&lang=js"
export * from "./SleepWorkshopComp.vue?vue&type=script&lang=js"
import style0 from "./SleepWorkshopComp.vue?vue&type=style&index=0&id=32f0f709&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f0f709",
  null
  
)

/* custom blocks */
import block0 from "./SleepWorkshopComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports